import { render } from "./TicketTransferTemplate.vue?vue&type=template&id=699e8b06"
import script from "./TicketTransferTemplate.vue?vue&type=script&lang=js"
export * from "./TicketTransferTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__